export enum ActivityCategory {
  BAR = 'BAR',
  BEACH = 'BEACH',
  BREAKFAST = 'BREAKFAST',
  BRUNCH = 'BRUNCH',
  CHEF = 'CHEF',
  COFFEE = 'COFFEE',
  COOKING = 'COOKING',
  CYCLING = 'CYCLING',
  DINNER = 'DINNER',
  DRINKS = 'DRINKS',
  EXTREMESPORTS = 'EXTREMESPORTS',
  FITNESS = 'FITNESS',
  FREEDIVING = 'FREEDIVING',
  HIKE = 'HIKE',
  LUNCH = 'LUNCH',
  MOUNTAINBIKING = 'MOUNTAINBIKING',
  OTHER = 'OTHER',
  PARK = 'PARK',
  PARTY = 'PARTY',
  POWERBOATING = 'POWERBOATING',
  SAILING = 'SAILING',
  SCUBADIVING = 'SCUBADIVING',
  SNOWSPORTS = 'SNOWSPORTS',
  SURFING = 'SURFING',
  TOUR = 'TOUR',
  TRAVEL = 'TRAVEL',
  WATERSPORT = 'WATERSPORT',
  WELLNESS = 'WELLNESS',
  YOGA = 'YOGA',
}

export enum Currency {
  USD = 'USD',
  CAD = 'CAD',
  JPY = 'JPY',
  EUR = 'EUR',
  GBP = 'GBP',
}

export enum BookableTypes {
  ACTIVITY = 'ACTIVITY',
  ACCOMMODATION = 'ACCOMMODATION',
  TRANSPORTATION = 'TRANSPORTATION',
}

export enum AccommodationType {
  HOUSE = 'HOUSE',
  HOTEL = 'HOTEL',
  CHALET = 'CHALET',
  LODGE = 'LODGE',
  CAMPSITE = 'CAMPSITE',
}

export enum BookableProviders {
  LOCAL = 'LOCAL',
  VIATOR = 'VIATOR',
}

export enum AgeBandType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  YOUTH = 'YOUTH',
  INFANT = 'INFANT',
  SENIOR = 'SENIOR',
  TRAVELER = 'TRAVELER',
}

export enum DaysOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export enum PricingUnit {
  UNIT = 'UNIT',
  PER_PERSON = 'PER_PERSON',
}

export enum UnitType {
  GROUP = 'GROUP', // Per-group pricing – calculated based on the number of groups
  ROOM = 'ROOM', // Per-room pricing – calculated based on the number of rooms
  PACKAGE = 'PACKAGE', // Per-package pricing – calculated as part of a package
  VEHICLE = 'VEHICLE', // Per-vehicle pricing – calculated based on the number of vehicles
  BIKE = 'BIKE', // Per-bike pricing – identical to "per vehicle", but refers to bikes
  BOAT = 'BOAT', // Per-boat pricing – identical to "per vehicle", but refers to boats
  AIRCRAFT = 'AIRCRAFT', // Per-aircraft pricing – identical to "per vehicle", but refers to aircraft
}

export enum Roles {
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  SUPPLIER = 'SUPPLIER',
}

export enum BookingStatus {
  CREATEDINCOMPLETE = 'CREATEDINCOMPLETE',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
}

export enum BookableStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  INTERVIEW = 'INTERVIEW',
}
